import { ChevronsUpDown, LogOut, Settings } from 'lucide-react'
import { TESTID } from '../lib/testids'
import { Avatar, AvatarFallback } from './ui/avatar'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu'
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from './ui/sidebar'

export function NavUser({
  userName,
  onSettings,
  onLogout,
}: {
  userName: string
  onSettings?: () => void
  onLogout: () => void
}) {
  const { isMobile } = useSidebar()
  const avatar = (userName.charAt(0) || 'U').toUpperCase()

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger
            render={
              <SidebarMenuButton
                size="lg"
                className="data-open:bg-sidebar-accent data-open:text-sidebar-accent-foreground"
                data-testid={
                  isMobile
                    ? TESTID.userMenuTriggerMobile
                    : TESTID.userMenuTrigger
                }
              />
            }
          >
            <Avatar className="size-8 rounded-full">
              <AvatarFallback>{avatar}</AvatarFallback>
            </Avatar>
            <span className="min-w-0 flex-1 truncate text-left text-sm">
              {userName}
            </span>
            <ChevronsUpDown className="ml-auto size-4" />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="min-w-56 rounded-lg"
            side={isMobile ? 'bottom' : 'right'}
            align="end"
            sideOffset={4}
            data-testid={
              isMobile ? TESTID.userMenuDropdownMobile : TESTID.userMenuDropdown
            }
          >
            <DropdownMenuGroup>
              <DropdownMenuLabel className="truncate px-2 py-1.5 font-normal">
                {userName}
              </DropdownMenuLabel>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            {onSettings && (
              <>
                <DropdownMenuItem
                  onClick={onSettings}
                  data-testid={
                    isMobile ? TESTID.menuSettingsMobile : TESTID.menuSettings
                  }
                >
                  <Settings />
                  Settings
                </DropdownMenuItem>
                <DropdownMenuSeparator />
              </>
            )}
            <DropdownMenuItem
              onClick={onLogout}
              data-testid={
                isMobile ? TESTID.logoutButtonMobile : TESTID.logoutButton
              }
            >
              <LogOut />
              Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
